<template>
    <div class="row container-fluid m-auto text-center">
        <div class="col-md-6" v-for="item in teamData" :key="item.id">
            <div class="bg-light mx-1 px-3 pb-3 mb-4 shadow-sm">
                <img class="w-50 rounded-circle m-3 shadow"
                     :src="path + item.image"
                     :alt="`Снимка на ${item.name}`">
                <h5>{{ item.name }}</h5>
                <button type="button" class="btn btn-primary" @click="openModal(item)">
                    виж още
                </button>
            </div>
        </div>

        <!-- Single modal, rendered once outside the v-for -->
        <div class="modal fade" id="team-modal" tabindex="-1" role="dialog"
             aria-labelledby="teamModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content" v-if="selectedItem">
                    <div class="modal-header">
                        <h5 class="modal-title" id="teamModalTitle">{{ selectedItem.name }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body" v-html="selectedItem.description"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap';

export default {
    props: ['teamData'],
    data() {
        return {
            path: process.env.VUE_APP_IMAGE_PATH,
            selectedItem: null
        }
    },
    methods: {
        openModal(item) {
            this.selectedItem = item;
            this.$nextTick(() => {
                const el = document.getElementById('team-modal');
                Modal.getOrCreateInstance(el).show();
            });
        }
    }
}
</script>

<style scoped>
img {
    border: 0.5rem solid #fff;
}
</style>
